import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Progress, Alert, Input, Col } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

import logo from './img/logo.png'

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate } = useLocalization();
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);
        let message = translate("RequestLoginErrorMessage")
        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div className="login-cableplay-container" ref={nodeRef}>
        <div className="login-cableplay-header">
          <img src={logo} alt="Cable Play" className="logo-cableplay" />
          <h2 className="h2">{translate("ClientAuthentication")}</h2>
        </div>
        <div className="login-cableplay-body">
          <Form onSubmit={event => onSubmit(event)}>
            <Col sm="12" xs="12" md="12">
              <Input
                className="input-cableplay"
                disabled={onLogin}
                required={true}
                type="text"
                id="username"
                placeholder={translate("PlaceholderUserName")}
                onChange={e => setUsername(e.target.value)}
              />
            </Col>
            <Col sm="12" xs="12" md="12">
              <Input
                className="input-cableplay"
                required={true}
                disabled={onLogin}
                type="password"
                id="password"
                placeholder={translate("PlaceholderPassword")}
                onChange={e => setPassword(e.target.value)}
              />
            </Col>
            {!onLogin ? (
              <button
                className="enter-cableplay"
                type="submit"
                name="submit"
                disabled={!props.turnstileSuccess}
              >
                INGRESAR
              </button>
            ) : (
              <Progress animated color="primary" value={100} />
            )}
            <div className="messages-container">
              <Alert color="danger" isOpen={error.open} toggle={() => setError({ open: false })}>
                {error.message}
              </Alert>
            </div>
          </Form>
        </div>
        <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
      </div>
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm, { useInsideForm: true, style: { marginTop: '2rem' } });
